/**
 * Small company contact block shown on public-facing pages (login/register)
 * so visitors can reach FastSend before they even have an account.
 */
export default function ContactFooter() {
  return (
    <div
      style={{
        marginTop: "28px",
        paddingTop: "16px",
        borderTop: "1px solid var(--border)",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <a href="https://fastsend.ng" target="_blank" rel="noreferrer" className="hint" style={{ color: "var(--text-accent)", textDecoration: "none" }}>
        🌐 fastsend.ng
      </a>
      <a href="mailto:send@fastsend.ng" className="hint" style={{ textDecoration: "none" }}>
        ✉️ send@fastsend.ng
      </a>
      <a href="tel:+2349098168038" className="hint" style={{ textDecoration: "none" }}>
        📞 09098168038
      </a>
    </div>
  );
}
